import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ListButton } from '@app/core/components/list/list.component';
import { RememberService } from '@app/core/services/remember.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustomerItem, TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-select-customer',
    templateUrl: './select-customer.component.html',
    styleUrls: ['./select-customer.component.css'],
    standalone: false,
})
export class SelectCustomerComponent implements OnInit {
    public items: CustomerItem[] = [];
    public searchText = '';
    public lastSelection: 'LAST' | 'SEARCH' = 'LAST';
    public customerType: 'C' | 'S' | 'O' = 'C';
    public loading = false;
    public error = '';
    private pendingLoads = 0;
    public readonly rowButtons: ListButton<CustomerItem>[] = [{
        id: 'newtab', icon: 'fas fa-external-link', type: 'secondary',
        onClick: ({ item }) => {
            if (item.item_state === '') return;
            this.navigator?.newTab({ to: item.item_state, parms: item.item_parms });
        },
    }];

    constructor(
        private typeahead: TypeaheadService,
        private remember: RememberService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public ngOnInit(): void { void this.loadCustomers(); }

    public async loadCustomers(): Promise<void> {
        if (typeof this.searchText !== 'string') return;
        this.items = [];
        ++this.pendingLoads;
        this.loading = true;
        this.error = '';
        try {
            this.items = await this.typeahead.searchCustomer({
                cust_name: this.searchText, filtertype: '', filtervalue: '',
                custtype: this.customerType, lastselect: this.lastSelection,
            });
        } catch (error) { this.showError(error); }
        finally { this.loading = --this.pendingLoads > 0; }
    }

    public search(): void {
        if (!this.loading) void this.loadCustomers();
    }

    public clearSearch(): void {
        this.searchText = '';
        void this.loadCustomers();
    }

    public changeLastSelection(value: string): void {
        if (value !== 'LAST' && value !== 'SEARCH') return;
        this.lastSelection = value;
        void this.loadCustomers();
    }

    public changeCustomerType(value: string): void {
        if (value !== 'C' && value !== 'S' && value !== 'O') return;
        this.customerType = value;
        void this.loadCustomers();
    }

    public select(item: CustomerItem): void {
        if (item.item_id === '') return;
        // Legacy selection starts the remember write and returns immediately.
        void this.remember.remember('selected_cust_no', item.item_id).catch(error => this.showError(error));
        this.navigator?.back();
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
